import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import UpdateLicense from './update-license'
import appDisplay from 'scoreboard/components/app-display'
import template from './license-form.hbs'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import Tooltip from 'scoreboard/components/tooltip'
import LinkDatabase from './link-database'
import i18n from 'scoreboard/components/i18n'
import license from 'scoreboard/components/license'
import constants from 'scoreboard/components/constants'
import globals from 'scoreboard/components/globals'
import menuManager from 'scoreboard/menu-manager'

const UNLIMITED = -1
/**
 * This form appears in a dialog when you click "Edit" in the upper right corner
 * of a license panel
 *
 * PSD location: administration\license management\license-management-edit-license.psd
 */
var LicenseForm = Backbone.View.extend({

	// this.license is the license
	// this.unlinkedDatabases is an array of the unlinked databases

	className: 'edit-license',

	events: {
		'click .license-update': 'updateLicense',
		'click .license-delete': 'deleteLicense',
		'click .link-db': 'linkDatabase',
		'click .unlink-db' : 'unlinkDatabase'
	},

	initialize: function(options) {
		this.options = options || {}
		this.license = this.options.license
		this.unlinkedDatabases = this.options.unlinkedDatabases || []
	},

	render: function() {
		this.$el.empty().append(template(this.license))
		var errors = []
		,	list = this.$('ul.list-striped')
		,	databases = []

		this.listItemTemplate = list.find('li').detach()
		_.each(this.license.usage, usage => {
			databases.push(usage.dbInfo)
			if (usage.exceeded) {
				errors.push(usage.dbInfo.label)
			}
		})

		// Sort the databases alphabetically by label and render the list entries for them
		_.each(_.sortBy(databases, d => d.label), sorted => {
			list.append(this.renderDatabase(sorted))
		})

		var bannerError = this.$('.banner-error')
		if (this.license.databasesExceeded) {
			bannerError.append('<p>'+i18n.get('admin.licenses.numDatabasesExceeded')+'</p>')
		}
		if (errors.length) {
			bannerError.append('<p>'+i18n.get('admin.licenses.databasesExceedingUsage')+'</p>')
			var errorList = ''
			_.map(errors, function(label) {
				errorList += '<li>'+label+'</li>'
			}.bind(this))
			bannerError.append('<ul>'+errorList+'<ul>')
			bannerError.addClass('has-multiple-errors')
		}
		this.$el.toggleClass('has-error', errors.length > 0 || this.license.databasesExceeded)

		if (_.size(this.license.usage) === 0) {
			list.addClass('is-not-displayed')
			this.$('.no-databases').removeClass('is-not-displayed')
		}
		this._toggleLinkDb()
		return this
	},

	// toggles the "Add DB" button based on whether the maximum number of
	// databases have already been added to the license
	_toggleLinkDb: function() {
		if (this.license.databases !== UNLIMITED) {
			var maxed = _.size(this.license.usage) >= this.license.databases
			this.$('.link-db').toggleClass('is-not-displayed', maxed)
		}
	},

	renderDatabase: function(db) {
		var item = this.listItemTemplate.clone()
		item.data('database-id', db.id)
		item.find('.database-name').text(db.label)
		return item
	},

	updateLicense: function() {
		var form = new UpdateLicense({ license: this.license })
		appDisplay.dialog(form)
		form.on('done', function(license) {
			this.license = license
			Backbone.trigger('update:license', {license: this.license})
			this.render()
		}.bind(this))
	},

	deleteLicense: function() {
		var confirmation = new DeleteConfirmation(this.license)
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', function() {
			$.delete('api/admin/licenses/' + this.license.id, function() {
				this._toggleLinkDb()
				// close the confirmation dialog
				confirmation.trigger('done')
				// close the EditLicenses dialog
				this.trigger('done')
				// fire an event so we can re-draw the list of licenses
				Backbone.trigger('delete:license', this.license)

				//trigger config mode if deleting license of current database
				var currentDbLicense = _.find(this.license.usage || [], function(license) {
					return license.dbInfo ? license.dbInfo.id == globals.database.id : null
				}.bind(this))
				if (currentDbLicense) {
					globals.mode = constants.MODE_CONFIGURE
				}
			}.bind(this))
		}.bind(this))
	},

	linkDatabase: function() {
		if (_.isEmpty(this.unlinkedDatabases)) {
			this.tooltip = new Tooltip({
				attachTo: this.$('.link-db'),
				content: i18n.get('admin.licenseUsage.noUnlinkedDatabases'),
				placement: 'below',
				arrow: 'right'
			}).render()
			return
		}

		var form = new LinkDatabase({ unlinkedDatabases: this.unlinkedDatabases })
		_.result(this.tooltip, 'remove')
		this.tooltip = new Tooltip({
			attachTo: this.$('.link-db'),
			content: form.render().el,
			placement: 'below',
			arrow: 'right',
			extraClass: 'link-database-tooltip'
		}).render()
		form.on('select', function(db) {
			this._toggleLinkDb()
			this.tooltip.remove()
			var url = 'api/admin/licenses/' + this.license.id + '/link'
			$.post(url, JSON.stringify(db.id), function(data) {
				this.refresh(data)
				if (db.id == _.result(globals, 'database.id')) {
					license.set(this.license)
					menuManager.operationalize()
				}
			}.bind(this))
		}.bind(this))
	},

	unlinkDatabase: function(e) {
		var row = this.$(e.target).closest('li')
		var dbId = row.data('database-id')
		var url = 'api/admin/licenses/' + this.license.id + '/unlink'
		if (dbId == globals.database.id) {
			license.remove()
			globals.mode = constants.MODE_CONFIGURE
		}
		$.post(url, JSON.stringify(dbId), this.refresh.bind(this))
	},

	refresh: function(data) {
		// refresh the data
		this.license = _.find(data.licenses, function(license) {
			return license.id == this.license.id
		}.bind(this))
		this.unlinkedDatabases = data.unlinkedDatabases
		this.render()
		// resize the dialog
		this.trigger('resize')
		// re-draw the admin-licenses page
		this.trigger('refresh', data)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.tooltip], 'remove')
	}

})

export default LicenseForm

LicenseForm.__filename__ = 'admin/licenses/license-form.js'
